import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { Platform, LocaleRegex } from '@/env'
import dayjs from 'dayjs'
import { API_CONST, setHeaders } from '@/apis'
import { resources } from './resources'

export type LanguageKeys = 'zh' | 'en' | 'vi' | 'th' | 'id' | 'ko' | 'ms' | 'ja' | 'ph'

export const LANGUAGES: LanguageKeys[] = ['en', 'zh', 'vi', 'th', 'id', 'ko', 'ms', 'ja', 'ph']

export const namespaces = Object.keys(resources.en) // 以 en 為主

// 取得 storage 中設定的語系
const lng = localStorage.getItem('okbet-lang')

if (lng) {
  setHeaders({ [API_CONST.X_LANG]: lng })
}

export const i18nReady = i18n.use(initReactI18next).init({
  resources,
  lng: lng || Platform.LOCALE, // 預設語言
  fallbackLng: 'en', // 無對應翻譯時的備援語言
  interpolation: {
    escapeValue: false, // React 已處理 XSS，不需轉義
    // prefix: '{', // 設定前綴為 "{"
    // suffix: '}', // 設定後綴為 "}"
    // alwaysFormat: true, // 設定總是格式化
  },
  ns: namespaces,
  defaultNS: 'common',
})

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('okbet-lang', lng)
})

/** 設定語系 */
export const setLocale = async (locale: string) => {
  // 不存在的語系
  if (!Platform.LOCALES.includes(locale)) return
  setHeaders({ [API_CONST.X_LANG]: locale })

  i18n.changeLanguage(locale)
  dayjs?.locale(locale)
  // html lang
  document.documentElement.lang = locale
}

export default i18n
